import { useGetRegexes } from "./services";

const pandoRegex = /^(?<prefix>[A-Z])(?<number>\d{5})(?<checksum>\d)$/

/** Sum all digits of a number. */
function reduce(code, ponderation) {
  if (typeof(code)==='number' && code<10) {
    return code;
  } else if (typeof(code)==='number') {
    return reduce(String(code));
  }
  let sum = 0;
  for (var k=0; k<code.length; k++) {
    let d = Number(code[k])
    if (k % 2 === 0) { d *= (ponderation || 1) }
    //if (d > 9) { d = reduce(String(d)) }
    sum += d
  }
  return sum
};

/** Generate the code with the check digit to be used a bac_shown_id. */
function generate_code(number, digits, prefix) {
  let sum = 0;
  if (prefix) {
    //sum += reduce(prefix.charCodeAt() - 'A'.charCodeAt() + 1);
    sum += prefix.charCodeAt() - 'A'.charCodeAt() + 1;
  }
  const code = (Array(digits+1).join('0') + number).slice(-digits);
  // I don't use repeat for IE compatibility
  //const reverse = ('' + sum + code).split('').reverse().join('')
  const reverse = code.split('').reverse().join('')
  //sum = reduce(reverse, 3);
  sum += reduce(reverse, 3);
  sum = sum % 10;
  const check_digit = sum===0 ? 0 : 10 - sum;
  return ( (prefix || '') + code + check_digit );
};

/** Check if string is a valid bac shown id. */
const useFormatBacId = () => {
  const regexes = useGetRegexes();
  return value => {
    if (value===undefined || value===null || value==='') {
      return "Un code ne peut être vide."
    }
    if (/[^a-zA-Z0-9]/.test(value)) {
      return "Un code n'est composé que de chiffres et de lettres."
    }
    for (const regex of regexes) {
      if (value.match(regex)?.groups?.id) { return undefined; }
    }
    const code = value?.match(pandoRegex)?.groups;
    if (!code || value!==generate_code(+code.number, 5, code.prefix)) {
      return "Le code ne correspond à aucun format connu."
    }
  }
};

export { generate_code, useFormatBacId }
